import React from 'react'
import styled, { keyframes } from 'styled-components'
import PropTypes from 'prop-types'
import Icon from 'components/common/Icon/Icon'
import Theme from 'components/common/Theme/Theme'
import { FAVORITE_LINK_ID, FAVORITE_LINK_HEART_ID } from './../constants'
import Button from 'components/common/Button/Button'

const FavoriteLinkButton = ({ className, isFavorite, handleClick }) =>
  <FavoritesLink link id={ FAVORITE_LINK_ID } className={ className } onClick={ handleClick } >
    <HeartIcon
      id={ FAVORITE_LINK_HEART_ID }
      alt="Heart icon"
      aria-hidden="true"
      asset={ isFavorite ? 'heart-red-filled' : 'heart-red' } />
    <FavoritesLinkText>
      {isFavorite ? 'Remove from ' : 'Add to '} Favorites
    </FavoritesLinkText>
  </FavoritesLink>

FavoriteLinkButton.propTypes = {
  className: PropTypes.string,
  handleClick: PropTypes.func,
  isFavorite: PropTypes.bool
}

const scaleInOut = keyframes`
  0% { transform: scale(1); }
  50% { transform: scale(2.8); }
  100% { transform: scale(1); }
`

const FavoritesLinkText = styled.span`
  margin: 0 0 0 5px;
  font-size: 12px;
  color: ${Theme.colors.blue};
`

const FavoritesLink = styled(Button)`
  display: flex;
  justify-content: center;
  line-height: 17px;
  padding: 0 10px;
`

const HeartIcon = styled(Icon)`
  width: 15px;
  height: 15px;

  &.scale-in-out {
    animation: ${scaleInOut} 300ms linear;
  }
`

export default FavoriteLinkButton
